<template>
    <div class="member-popup-wrapper" v-show="isShowPopup">
        <div class="member-popup-cover"></div>
        <div class="member-popup-container">
            <div class="member-popop-banner">
                <img :src="banner" />
            </div>

            <div class="member-popup-body">
                <p class="text__big">成为骑士会员 立享当前权益</p>

                <p class="text__small">
                    加油<strong class="font-064-CAI978 text__small__red">7</strong>折起，还有更多300+特权
                </p>
            </div>

            <div class="member-popup-footer">
                <div class="member-popup-button">立即开通</div>
            </div>

            <div class="close-container">
                <i class="icon-close" @click="mutationShowPopup(false)" />
            </div>
        </div>
    </div>
</template>

<script>
// import '@/promo/nationalCollectCoin/assets/style/common.scss';

export default {
    data() {
        return {
            isShowPopup: false,

            banner: require('../../assets/images/banner.png'),
        };
    },
    methods: {
        mutationShowPopup(status) {
            this.isShowPopup = status;
            !status && this.$emit('close-popup');
        },
    },
};
</script>

<style lang="scss" scoped>
.member-popup-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;

    .member-popup-cover {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        z-index: 2000;
    }

    .member-popup-container {
        width: 6.3rem;
        height: 5.37rem;
        border-radius: 0.16rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-3.15rem, calc(-2.685rem - 0.3rem));
        background: #fff;
        z-index: 2001;

        .member-popop-banner {
            width: 100%;
            height: 2.2rem;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .member-popup-body {
            width: 100%;
            margin-top: 0.4rem;
            text-align: center;
            color: #333;

            .text__big {
                font-size: 0.32rem;
                font-weight: 600;
            }

            .text__small {
                font-size: 0.28rem;
                font-weight: 400;
                margin-top: 0.14rem;
                display: inline-flex;
                align-items: center;

                &__red {
                    color: #ff3838;
                    font-size: 0.5rem;
                    position: relative;
                    bottom: 0.06rem;
                    margin: 0 0.03rem;
                }
            }
        }

        .member-popup-footer {
            width: 5.1rem;
            height: 0.88rem;
            background: linear-gradient(90deg, #4f4f4f 0%, #252220 100%);
            border-radius: 0.44rem;
            margin: 0.16rem auto 0;
            color: #f8e3c0;
            animation: animatedScale 1.8s linear infinite;

            .member-popup-button {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: 0 0 / contain no-repeat url(../../assets/images/light.png);
                animation: animatedBackground 1.8s linear infinite;
            }
        }
    }
}

.close-container {
    position: absolute;
    bottom: calc(-0.52rem - 0.6rem);
    left: 50%;
    transform: translateX(-0.26rem);

    .icon-close {
        display: inline-block;
        width: 0.52rem;
        height: 0.52rem;
        background: center / contain no-repeat url(../../assets/images/close.png);
    }
}

@keyframes animatedBackground {
    0% {
        background-position: 0 0;
    }
    30% {
        background-position: 120% 0;
    }
    100% {
        background-position: 120% 0;
    }
}

@keyframes animatedScale {
    0% {
        transform: scale(1);
    }
    45% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    60% {
        transform: scale(1);
    }
    70% {
        transform: scale(1.05);
    }
    80% {
        transform: scale(1);
    }
}
</style>
